var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-xs-center", staticStyle: { width: "52px" } },
    [
      _c(
        "v-menu",
        {
          directives: [
            {
              name: "scroll",
              rawName: "v-scroll",
              value: _vm.onScroll,
              expression: "onScroll"
            }
          ],
          attrs: { bottom: "", left: "" },
          model: {
            value: _vm.menu,
            callback: function($$v) {
              _vm.menu = $$v
            },
            expression: "menu"
          }
        },
        [
          _c("wz-avatar", {
            attrs: {
              slot: "activator",
              src: _vm.userAvatar + "?" + Math.random(),
              username: _vm.fullName,
              size: "32px"
            },
            slot: "activator"
          }),
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { "two-line": "" } },
            [
              _c(
                "v-list-tile",
                { attrs: { to: "/profile" } },
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c("wz-avatar", {
                        attrs: {
                          src: _vm.userAvatar + "?" + Math.random(),
                          username: _vm.fullName,
                          size: "48px"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [_vm._v(_vm._s(_vm.fullName))]),
                      _vm._v(" "),
                      _c("v-list-tile-sub-title", [
                        _vm._v(_vm._s(_vm.account.type))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            { staticClass: "card", attrs: { dense: "" } },
            [
              _vm.checkPermission("NO_AGENTS")
                ? _c(
                    "v-list-tile",
                    { attrs: { to: "/account" } },
                    [
                      _c(
                        "v-list-tile-action",
                        [_c("v-icon", [_vm._v("business_center")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-tile-title", [
                        _vm._v(_vm._s(_vm._f("cap")(_vm.$t("gestionAccount"))))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-list-tile",
                { attrs: { href: _vm.checkUrlSupport, target: "_blank" } },
                [
                  _c(
                    "v-list-tile-action",
                    [_c("v-icon", [_vm._v("launch")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-tile-title", [
                    _vm._v(_vm._s(_vm._f("cap")(_vm.$t("support"))))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-list-tile",
                {
                  on: {
                    click: function($event) {
                      _vm.dialog = true
                    }
                  }
                },
                [
                  _c(
                    "v-list-tile-action",
                    [_c("v-icon", [_vm._v("power_settings_new")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-tile-title", [
                    _vm._v(_vm._s(_vm._f("cap")(_vm.$t("logout"))))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("logout"))) + " ?")]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("textDeconnexion")) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: _vm.isLogout, flat: "flat" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.isLogout,
                        loading: _vm.isLogout,
                        color: "primary"
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.logout()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("logout")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f019d200", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f019d200","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentMenu.vue
// module id = null
// module chunks = 